import { Amplify } from "aws-amplify";

export function configureAmplify() {
  let ob = {
    region: process.env.REACT_APP_AWS_REGION,
    userPoolId: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_AWS_COGNITO_OTA_APP_CLIENT_ID,
    authenticationFlowType: "USER_SRP_AUTH",
    oauth: {
      domain: process.env.REACT_APP_AWS_OAUTH_DOMAIN,
      scope: [
        "openid",
        "email",
        "profile",
        "phone",
        "aws.cognito.signin.user.admin",
      ],
      redirectSignIn: process.env.REACT_APP_AWS_OAUTH_RD_SIGNIN,
      redirectSignOut: process.env.REACT_APP_AWS_OAUTH_RD_SIGNOUT,
      responseType: "code", // Authorization Code grant with PKCE
    },
  };
  console.log(ob);
  Amplify.configure({
    Auth: ob,
  });

  /*axios.get(Constants.SERVER_CONFIG).then((result) => {
    Amplify.configure({
      Auth: {
        region: result.data.cognito.AWS_REGION,
        userPoolId: result.data.cognito.USER_POOL_ID,
        userPoolWebClientId: result.data.cognito.USER_POOL_WEBCLIENT_ID,
        authenticationFlowType: "USER_PASSWORD_AUTH",
      },
    });
  });*/
}
